export enum DawbaRoutes {
  LoginPage = '',
  ChoosePatientPage = 'choose-patient',
  DashboardPage = 'dashboard',
  ExitPage = 'exit',
  OnboardingPage = 'onboarding',
  NoTaskAvailablePage = 'no-task-available',
  QuestionnairePage = 'qnr',
  IntroToSsdqPage = 'ssdq-intro',
  IntroToIntroPage = 'intro-intro',
  DevAdminPage = 'dev-admin',
  ErrorPage = 'error',
  MitIdCallback = 'mitid-callback',
  InactiveLogoutConfirm = 'logout-confirm',
}
